import { ClassData } from "../dtos/classes.type";

export const getUniqueLocationsList = (
  data: ClassData[],
  type: "short" | "long" = "long"
): Array<{ value: string; label: string; labelDescription: string }> => {
  const uniqueLocations = data
    .filter(
      (item, index, self) =>
        index === self.findIndex((x) => x.location_name === item.location_name)
    )
    .filter((item) => item.location !== "HAM"); // REALLY BAD - FIX IT WHEN YOU HAVE TIME

  return uniqueLocations.map((item) => {
    return {
      value: item.location_name,
      labelDescription: `${item.location_addr1} ${item.location_city} ${item.location_state} ${item.location_postalcode}`,
      label:
        type === "long"
          ? `${item.location_code} | ${item.location_city}`
          : item.location_name,
    };
  });
};

export const buildAddressFromClassDataLocations = ({
  location_addr1,
  location_addr2,
  location_city,
  location_code,
  location_name,
  location_state,
  location_postalcode,
}: ClassData): string => {
  const addressLines = [location_addr1?.trim(), location_addr2?.trim()].filter(
    Boolean
  );

  const cityStateZip =
    location_city && location_state && location_postalcode
      ? `${location_city}, ${location_state} ${location_postalcode}`
      : `${location_code} ${location_name}`;

  return addressLines.length
    ? [...addressLines, cityStateZip].join(" ")
    : cityStateZip;
};
